import {setPosition} from "@/api/data";
import COVERAPP from "@/utils/COVERAPP";
import moment from 'moment'


export const RandomNumBoth = (Min, Max) => {
    let Range = Max - Min;
    let Rand = Math.random();
    let num = Min + Math.round(Rand * Range);
    return num;
};

export const shareTitle = () => {
    let rankArray = [
        {title: "欢迎体验智媒云大模型生态-DeepSeek版", desc: "与AI两会进行深度对话"}
    ];
    const random = RandomNumBoth(0, rankArray.length - 1);
    return rankArray[random];
};

export const insertStr = (soure, start, newStr) => {
    return soure.slice(0, start) + newStr + soure.slice(start);
};

export const parseData = (list, string) => {
    let array = [];
    for (let i = 0; i < list.length; i++) {
        if (list[i].indexOf(string) !== -1) {
            let tag = list[i].indexOf(string);
            let tag1 = "<span style=\"color: #1890ff\">".length;
            let flag1 = insertStr(list[i], tag, "<span style=\"color: #1890ff\">");
            let flag2 = insertStr(flag1, tag + string.length + tag1, "</span>");
            array.push(flag2);
        } else {
            array.push(list[i]);
        }
    }
    return array;
};


//解决ios点击空白区域键盘收回问题
export const objBlurFun = (device, sDom, time = 100) => {  //sDom, input / textarea 都可以。
    if (device == "ios") {  // 如果是ios环境下
        let obj = document.querySelector(sDom);   // 这里如果传入的是2个以上 需要用querySelectorAll() 同时
        objBlur(obj, time);                  //  需要遍历调用函数
    }
};
export const objBlur = (sDom, time = 100) => {
    if (sDom) {
        sDom.addEventListener("focus", () => {
                document.addEventListener("touchend", e => {   // 这里的e非常重要，用来判断是否是点击了input表单
                    docTouchend(time, sDom, e);
                });
            },
            false
        );
    }
};
// 元素失去焦点隐藏iphone的软键盘
export const docTouchend = (time, sDom, e) => {
    if (e.target != sDom && e.target.className.indexOf("themeBig") < 0) {     // 如果点击的是 屏幕空白处的情况下
        setTimeout(() => {
            sDom.blur();      // 表单失去焦点  键盘就会自动收起

            window.scroll(0, 0);
            document.removeEventListener("touchend", docTouchend, false);   // 收起之后 移除监听器
        }, time);
    } else {
    }
};

/*获取地理位置*/

export const getLocationPoint = () => {
    const obj = {};
    return new Promise((resolve, reject) => {
        try {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    obj.latitude = position.coords.latitude;//获取纬度
                    obj.longitude = position.coords.longitude;//获取经度
                    resolve(obj);
                }, () => {
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            alert("定位失败,用户拒绝请求地理定位");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            alert("定位失败,位置信息是不可用");
                            break;
                        case error.TIMEOUT:
                            alert("定位失败,请求获取用户位置超时");
                            break;
                        case error.UNKNOWN_ERROR:
                            alert("定位失败,定位系统失效");
                            break;
                    }
                }, {
                    enableHighAccuracy: true,
                    timeout: 1000,
                    maximumAge: 1000
                });
            } else {
                alert("不支持定位功能");
            }
        } catch (e) {
            reject(e);
        }

    });
};

export const getBaiduLocation = () => {
    // 百度地图API功能

    let geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            setPosition({latitude: r.point.lat, longitude: r.point.lng});
        } else {
            setPosition({latitude: null, longitude: null});
            // alert('获取地理位置信息失败'+this.getStatus());
        }
    }, {enableHighAccuracy: true});
};


/* 判断字符串中是否包含某字符串 */
export const matchRegExps = (path, str) => {
    const regStr = new RegExp(path);
    return regStr.test(str);
};
export const createArray = (n, type) => {

//type :1 火   2：星星
    if (checkRate(n) && n <= 5) {

        let array = new Array(n).fill({});
        array.map((it, ix) => {
            it.star = type === 2 ? "tiny" : "star";
        });

        return array;
    } else {

        let array = new Array(Math.floor(n)).fill({});
        array.map((it, ix) => {
            it.star = type === 2 ? "tiny" : "star";
        });
        array.push({star: type === 2 ? "tinyic" : "starci"});
        return array;
    }

};

function checkRate(input) {
    let re = /^[1-9]+[0-9]*]*$/;   //判断字符串是否为数字     //判断正整数

    if (!re.test(input)) {
        return false;
    }
    return true;

}

//加载图片
export const defPreImage = (url) => {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = url;
        img.onload = function () {
            resolve(img);
        };
    });
};
//写字
export const writeText = (ctx, text, textStyle, width, left, top, lineHeight) => {
    ctx.font = `${textStyle.font} Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"`;
    ctx.textAlign = textStyle.align;
    ctx.textBaseline = textStyle.baseline;
    ctx.fillStyle = textStyle.color;
    let line = "";
    if (lineHeight) {
        for (let n = 0; n < text.length; n++) {
            let textLine = line + text[n];
            let metrics = ctx.measureText(textLine);
            let textWidth = metrics.width;
            if (textWidth > width && n > 0) {
                if ("，！。？；《".indexOf(text[n]) > -1) {
                    ctx.fillText(line.slice(0, n - 1), left, top);
                    line = `${text[n - 1]}${text[n]}`;
                } else {
                    ctx.fillText(line, left, top);
                    line = text[n];
                }
                top += lineHeight;
            } else {
                line = textLine;
            }
        }
    } else {
        line = text;
    }
    ctx.fillText(line, left, top);
    return ctx.measureText(line).width;
};

export function lastTime(time) {

    let date1 = new Date(time).valueOf();
    let date2 =   moment(time).endOf('day').format('x')
    let s = parseInt((date2 - date1) / 1000);


    if (s > 86400) {
        let days = s / 60 / 60 / 24;
        let daysText = Math.floor(days);
        let hours = s / 60 / 60 - (24 * daysText);
        let hoursText = Math.floor(hours);
        let minutes = s / 60 - (24 * 60 * daysText) - (60 * hoursText);
        let minutesText = Math.floor(minutes);
        let seconds = s - (24 * 60 * 60 * daysText) - (60 * 60 * hoursText) - (60 * minutesText);
        let secondsText = Math.round(seconds);
        // return daysText + "天" + hoursText + "时" + minutesText + "分" + secondsText + "秒";
        return [
            {
                name: "天",
                value: daysText < 10 ? `0${daysText}` : daysText
            },
            {
                name: "时",
                value: hoursText < 10 ? `0${hoursText}` : hoursText
            },
            {
                name: "分",
                value: minutesText < 10 ? `0${minutesText}` : minutesText
            },
            {
                name: "秒",
                value: secondsText < 10 ? `0${secondsText}` : secondsText
            }
        ];
    } else if (s > 3600 && s <= 86400) {
        let hours = s / 60 / 60;
        let hoursText = Math.floor(hours);
        let minutes = s / 60 - (60 * hoursText);
        let minutesText = Math.floor(minutes);
        let seconds = s - (60 * 60 * hoursText) - (60 * minutesText);
        let secondsText = Math.round(seconds);
        return [
            {
                name: "时",
                value: hoursText < 10 ? `0${hoursText}` : hoursText
            },
            {
                name: "分",
                value: minutesText < 10 ? `0${minutesText}` : minutesText
            },
            {
                name: "秒",
                value: secondsText < 10 ? `0${secondsText}` : secondsText
            }
        ];
    } else if (s > 60 && s <= 3600) {
        let minutes = s / 60;
        let minutesText = Math.floor(minutes);
        let seconds = s - (60 * minutesText);
        let secondsText = Math.round(seconds);
        return [
            {
                name: "时",
                value: "00"
            },
            {
                name: "分",
                value: minutesText < 10 ? `0${minutesText}` : minutesText
            },
            {
                name: "秒",
                value: secondsText < 10 ? `0${secondsText}` : secondsText
            }
        ];
    } else if (0 <= s && s <= 60) {
        let seconds = s;
        let secondsText = Math.round(seconds);
        return [
            {
                name: "时",
                value: "00"
            },
            {
                name: "分",
                value:"00"
            },
            {
                name: "秒",
                value: secondsText < 10 ? `0${secondsText}` : secondsText
            }
        ];
    } else {
        return [
            {
                name: "时",
                value: "23"
            },
            {
                name: "分",
                value:"59"
            },
            {
                name: "秒",
                value: '59'
            }
        ]
    }
}

export function drawRoundRect(cxt, x, y, width, height, radius) {

    cxt.beginPath();
    cxt.arc(x + radius, y + radius, radius, Math.PI, Math.PI * 3 / 2);
    cxt.lineTo(width - radius + x, y);
    cxt.arc(width - radius + x, radius + y, radius, Math.PI * 3 / 2, Math.PI * 2);
    cxt.lineTo(width + x, height + y - radius);
    cxt.arc(width - radius + x, height - radius + y, radius, 0, Math.PI * 1 / 2);
    cxt.lineTo(radius + x, height + y);
    cxt.arc(radius + x, height - radius + y, radius, Math.PI * 1 / 2, Math.PI);
    cxt.closePath();

}

export function fillRoundRect(cxt, x, y, width, height, radius, fillColor) {
    //圆的直径必然要小于矩形的宽高
    if (2 * radius > width || 2 * radius > height) {
        return false;
    }

    cxt.save();
    cxt.translate(x, y);
    //绘制圆角矩形的各个边
    drawRoundRectPath(cxt, width, height, radius);
    cxt.fillStyle = fillColor || "#000"; //若是给定了值就用给定的值否则给予默认值
    cxt.shadowOffsetX = 15; // 阴影Y轴偏移
    cxt.shadowOffsetY = 15; // 阴影X轴偏移
    cxt.shadowBlur = 14; // 模糊尺寸
    cxt.shadowColor = "rgba(6, 6, 6, 0.15)"; // 颜色
    cxt.fill();
    cxt.restore();
}

export function strokeRoundRect(cxt, x, y, width, height, radius, lineWidth, strokeColor) {
    //圆的直径必然要小于矩形的宽高
    if (2 * radius > width || 2 * radius > height) {
        return false;
    }

    cxt.save();
    cxt.translate(x, y);
    //绘制圆角矩形的各个边
    drawRoundRectPath(cxt, width, height, radius);
    cxt.lineWidth = lineWidth || 2; //若是给定了值就用给定的值否则给予默认值2
    cxt.strokeStyle = strokeColor || "#fff";
    cxt.stroke();
    cxt.restore();
}

export function drawRoundRectPath(cxt, width, height, radius) {
    cxt.beginPath(0);
    //从右下角顺时针绘制，弧度从0到1/2PI
    cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2);

    //矩形下边线
    cxt.lineTo(radius, height);

    //左下角圆弧，弧度从1/2PI到PI
    cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI);

    //矩形左边线
    cxt.lineTo(0, radius);

    //左上角圆弧，弧度从PI到3/2PI
    cxt.arc(radius, radius, radius, Math.PI, Math.PI * 3 / 2);

    //上边线
    cxt.lineTo(width - radius, 0);

    //右上角圆弧
    cxt.arc(width - radius, radius, radius, Math.PI * 3 / 2, Math.PI * 2);

    //右边线
    cxt.lineTo(width, height - radius);
    cxt.closePath();
}

Math.signFigures = function(num, rank = 6) {
    if(!num) return(0);
    const sign = num / Math.abs(num);
    const number = num * sign;
    const temp = rank - 1 - Math.floor(Math.log10(number));
    let ans;
    if (temp > 0) {
        ans = parseFloat(number.toFixed(temp));
    }
    else if (temp < 0) {
        ans = Math.round(number / Math.pow(10, temp)) * temp;
    }
    else {
        ans = Math.round(number);
    }
    return (ans * sign);
};

//获取当前月天数
function mGetDate() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let d = new Date(year, month, 0);
    return d.getDate();
}

//计算本月剩余天数占比
export const getLastDays = () => {
    let today = new Date();
    let now = today.getDate();
    let year = today.getYear();
    if (year < 2000) year += 1900; // Y2K fix
    let month = today.getMonth();
    let monarr = new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
    if (((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0)) monarr[1] = "29";
    return Math.signFigures(((monarr[month] - now) / mGetDate()).toFixed(2) * 100);
};

//获取今天年月日
export function getCurrentDay() {
    let date = new Date();
    date.setTime(date.getTime());
    let result = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    return result;
}

//本周开始结束时间
export function getWeekData() {
    let now = new Date();
    let nowTime = now.getTime();
    let day = now.getDay();
    let oneDayLong = 24 * 60 * 60 * 1000;

    let data = [];
    for (let i = 1; i < 8; i++) {
        let sundayTime = nowTime + (i - day) * oneDayLong;
        let SundayTime = new Date(sundayTime);
        let y = SundayTime.getFullYear();//年
        let m = SundayTime.getMonth() + 1;//月
        let d = SundayTime.getDate();//日
        let h = SundayTime.getHours();//时
        let mm = SundayTime.getMinutes();//分
        let s = SundayTime.getSeconds();//秒
        m = m < 10 ? "0" + m.toString() : m;
        d = d < 10 ? "0" + d.toString() : d;
        let val = y.toString() + "-" + m.toString() + "-" + d.toString();
        data.push(val);
    }
    console.info('data',data)
    return data;
}


export function getLastWeekDays() {
    const weekDays = getWeekData();

    const current = getCurrentDay();
    let flag = 0;
    try {
        weekDays.forEach((value, index, array) => {
            if (current === value) {
                flag = index;
                throw Error();
            }
        });
    } catch (e) {
    }
    console.info('flag',flag)
    return Math.signFigures(((7 - (flag + 1)) / 7).toFixed(2) * 100);
}


export const getDevice = () => {
    //  0:微信  1:app  2:qq   100：游客

    let deviceFlag = 100;
    if (COVERAPP.Attribute.isWeixin()) {
        deviceFlag = 0;
    }
    if (COVERAPP.Attribute.isApp()) {
        deviceFlag = 1;
    }
    if (COVERAPP.Attribute.isQQ()) {
        deviceFlag = 2;
    }
    return deviceFlag;

};


export const onTimeDiff=(server,browser)=>{
    return Math.abs(server-browser);
}

export function formatDate(date, formatter) {
    let dateTime = new Date(date)
    if (/(y+)/.test(formatter)) {
        formatter = formatter.replace(RegExp.$1, (dateTime.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': dateTime.getMonth() + 1,
        'd+': dateTime.getDate(),
        'h+': dateTime.getHours(),
        'm+': dateTime.getMinutes(),
        's+': dateTime.getSeconds()
    }

    for (let k in o) {
        if (new RegExp(`(${k})`).test(formatter)) {
            let str = o[k] + ''
            formatter = formatter.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
        }
    }
    return formatter
}

export function formatMonthDay(time) {
    return formatDate(time, "M月d日");
}

export function formatAudioTime(time) {
    // console.log(time)
    let minutes = Math.floor(time / 60)
    let seconds = Math.floor(time - minutes * 60)
    // console.log(minutes, seconds)
    return `${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`
}

export function audioDetailTemplate(list, name) {
    return [
        {
            "content": {
                "tips": `小封温馨提示：正在播放的是【${name}】，你还可以在下方自选频道哦`,
                "view": 100
            }
        },
        {
            "content": {
                "tips": "",
                "view": 28,
                "list": list
            }
        },
        {
            "content": {
                "tips": "",
                "view": 12,
                "list": [{
                    "color": "interest",
                    "name": "边听边玩其他的",
                    "id": "",
                    "value": "边听边玩其他的",
                    "radioType": 20
                }]
            }
        },
        {
            "content": {
                "tips": "",
                "view": 104,
                "list": {
                    "value": "audio"
                }
            }
        }
    ]
}

export function ximalayaDetailTemplate(list, name) {
    return [
        {
            "content": {
                "tips": `小封温馨提示：正在播放的是【${name}】，你还可以在下方自选频道哦`,
                "view": 100
            }
        },
        {
            "content": {
                "tips": "",
                "view": 31,
                "list": list
            }
        },
        {
            "content": {
                "tips": "",
                "view": 12,
                "list": [{
                    "color": "interest",
                    "name": "边听边玩其他的",
                    "id": "",
                    "value": "边听边玩其他的",
                    "radioType": 19
                }]
            }
        },
        {
            "content": {
                "tips": "",
                "view": 104,
                "list": {
                    "value": "audio"
                }
            }
        }
    ]
}

//弹出框
export function popConfirm(text, func1, func2) {
    let confirm = window.confirm(text);
    if (confirm==true){
        func1()
    }
    else{
        func2()
    }
}

// 获取用户的语音设置权限
export function  getUserMedia(constrains,success,error) {

    if (navigator.mediaDevices.getUserMedia) {
      // 最新标准API
    //   console.log("最新标准API");
      navigator.mediaDevices.getUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
    } else if (navigator.webkitGetUserMedia) {
      // webkit内核浏览器
    //   console.log("webkit内核浏览器");
      navigator.webkitGetUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
    } else if (navigator.mozGetUserMedia) {
      // Firefox浏览器
    //   console.log("Firefox浏览器");
      navigator.mozGetUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
    } else if (navigator.getUserMedia) {
      // 旧版API
    //   console.log("旧版API  ");
      navigator.getUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
    }
  }

//   调用摄麦克风
export function getmicrophone(success,error){
    // console.log("进入获取麦克风权限1",navigator.mediaDevices)
   
      // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
        // console.log("老的浏览器可能根本没有实现 mediaDevices");
      }
      
      // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
      // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
      
          // 首先，如果有getUserMedia的话，就获得它
          var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
      
          // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
          if (!getUserMedia) {
            // console.log("一些浏览器根本没实现它");
            return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
          }
      
          // 否则，为老的navigator.getUserMedia方法包裹一个Promise
          return new Promise(function(resolve, reject) {
            // console.log("为老的navigator.getUserMedia方法包裹一个Promise");
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        }
      }

    getUserMedia(
      { audio: true },
      function() {
        console.log("已点击允许,开启成功");
        success()
      },
      function(data) {
        
          error(data.name)
        console.log("出错的是什么？", data,data.name);
      }
    ); 
}